// Based off https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
document.addEventListener("DOMContentLoaded", function () {
    var countdowns = document.querySelectorAll(".countdown-clock");

    countdowns.forEach(function(countdown) {
        const deadline = countdown.getAttribute("data-deadline");

        function getTimeRemaining(endtime) {
            const total = Date.parse(endtime) - Date.parse(new Date());
            const seconds = Math.floor( (total/1000) % 60 );
            const minutes = Math.floor( (total/1000/60) % 60 );
            const hours = Math.floor( (total/(1000*60*60)) % 24 );
            const days = Math.floor( total/(1000*60*60*24) );

            return {
                total,
                days,
                hours,
                minutes,
                seconds
            }
        }

        function initializeClock(id, endtime) {
            //const clock = document.getElementById(id);
            const daysSpan = countdown.querySelector('.days');
            const hoursSpan = countdown.querySelector('.hours');
            const minutesSpan = countdown.querySelector('.minutes');
            const secondsSpan = countdown.querySelector('.seconds');

            function updateClock(){
                const t = getTimeRemaining(endtime);

                daysSpan.innerHTML = (t.days <= 0) ? 0 : t.days;
                hoursSpan.innerHTML = (t.hours <= 0) ? 0 : t.hours;
                minutesSpan.innerHTML = (t.minutes <= 0) ? 0 : t.minutes;
                secondsSpan.innerHTML = (t.seconds <= 0) ? 0 : t.seconds;

                if (t.total <= 0) {
                    clearInterval(timeinterval);
                    countdown.style.display = "none";

                    var completedDisplay = countdown.nextElementSibling;

                    completedDisplay.style.display = "inline-block";
                }
            }

            updateClock(); // run function once at first to avoid delay
            var timeinterval = setInterval(updateClock,1000);
        }

        initializeClock('clockdiv', deadline);
    });
    // document.querySelectorAll('a[href^="#"]:not(.toggle)').forEach(anchor => {
});